/***
 * Created on 2023/7/24
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect, useState} from 'react';
import myqnapcloud_img from '../../../static/img/service/myqnapcloud.svg';
import Dropdown from "../../common/form/dropdown";
import {useQuery} from "@tanstack/react-query";
import {apiGet} from "../../../service/api";
import ApplicationRecord from "./application_record";
import {useTranslation} from "react-i18next";
import ContentLoader from "../../common/content_loader";

function UserApplication(props) {
    const [sortType, setSortType] = useState('display_name');
    const { t, i18n } = useTranslation();

    const DROPDOWN_LIST = {
        display_name: t('@Application Name@'),
        updated_at: t('@Last Login Date@')
    }

    const onSortChange = (e, item) => {
        Object.entries(DROPDOWN_LIST).forEach(([key, value]) => {
            if (value === item) {
                setSortType(key);
                return;
            }
        })
    }

    const userApps = useQuery({
        queryKey: ['userApplications'],
        queryFn: async () => await apiGet(`/ajax/user/app?lang=${i18n.language}`)
    });

    return (
        <>
            {userApps.isFetching && <ContentLoader />}
            {!userApps.isFetching &&
                <>
                    <div className="page-toolbar shift-top-with-tabbar">
                        <div className="comp-toolbar">
                            <div className="toolbar">
                                <div className="toolbar__col-left display-flex flex-wrap-nowrap align-items-center">
                                    <div className="sort-label text-14 !mr-10">{t('@Sort by@')}：</div>
                                    <Dropdown data={Object.values(DROPDOWN_LIST)} initValue={DROPDOWN_LIST[sortType]}
                                              onClick={(e, item) => onSortChange(e, item)}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="page-body">
                        <div className="page-content page-content--applications">
                            <div className="applications-wrapper">
                                {
                                    userApps?.data && userApps.data.sort((a,b)=>{
                                        if (sortType === 'display_name') {
                                            return a.display_name.localeCompare(b.display_name);
                                        }
                                        else {
                                            return new Date(b.last_login_at) - new Date(a.last_login_at);
                                        }
                                    }).map(app => <ApplicationRecord data={app} key={app.app_id}/>)
                                }
                            </div>
                        </div>
                    </section>
                </>
            }
        </>
    );
}

export default UserApplication;